import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { createDiseaseProtocol } from 'api/auth.api';

export const useCreateDiseaseProtocol = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: createDiseaseProtocol,

    onSuccess: (res) => {
      toast({
        title: 'Disease protocol created',
        description: res?.data?.message || 'Created successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to create',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
